module.exports = __webpack_public_path__ + "static/media/sun-cloud.93bf7231.svg";